import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_async_btn = _resolveComponent("async-btn")!

  return (_ctx.show)
    ? (_openBlock(), _createBlock(_component_async_btn, _mergeProps({
        key: 0,
        task: _ctx.task
      }, _ctx.$attrs, {
        rounded: "",
        onClick: _ctx.reconnect
      }), null, 16, ["task", "onClick"]))
    : _createCommentVNode("", true)
}